const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;

export const uploadMixin = {
  props: {
    hasUploadFromLink: {
      type: Boolean
    },
    uploadToStoreMedia: {
      type: Boolean
    }
  },
  data() {
    return {
      v_hasUploadFromLink: this.hasUploadFromLink,
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'file',
      formData: {},
      fieldName: '',
      uploadedFiles: [],
      upload: false,
      // type: '',
      types: [],
      notSelectedType: false,
      loading: false,
      showNotification: true,
      fileCount: 0
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    typeChecked() {
      return this.uploadedFiles.length && this.uploadedFiles.every((file) => file.typeId);
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    remove(index) {
      this.uploadedFiles.splice(index, 1);
    },
    async uploadPreviewImage(event, rowId, apiFunction, storeId = null, handleResponse = null) {
      try {
        const fileList = event.target.files.length ? event.target.files : event.target.file;
        if (!fileList.length) return;

        const formData = new FormData();
        const fieldName = event.target.name;
        Array.from(Array(fileList.length).keys()).map((x) => {
          formData.append(fieldName, fileList[x], fileList[x].name);
        });
        formData.append('mediaId', rowId);
        if (storeId) formData.append('storeId', storeId);
        const response = await apiFunction(formData);
        if (handleResponse) handleResponse(response, rowId);
      } catch (error) {
        console.log(error.message);
      }
    },
    uploadDocuments(upload, files) {
      return new Promise(async (resolve, reject) => {
        try {
          this.loading = true;
          const data = await upload(this.formData, files);
          this.currentStatus = STATUS_INITIAL;
          if (this.showNotification) this.notificateSuccess(`Successfully uploaded ${this.uploadedFiles.length} files`);
          resolve(data);
          this.loading = false;
        } catch (err) {
          this.loading = false;
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
          reject(err);
        } finally {
          this.v_hasUploadFromLink = this.hasUploadFromLink;
        }
      });
    },
    filesChange(fieldName, fileList) {
      this.fieldName = fieldName;
      // handle file changes
      const uploadedFiles = Object.keys(fileList).map((x) => fileList[x]);
      if (uploadedFiles.length) this.v_hasUploadFromLink = false;
      uploadedFiles.forEach((file) => {
        file.typeId = this.type || '';
        const { name, size, type } = file;
        this.uploadedFiles.push({ file, name, size, type, fileType: this.types[0], title: null, compress: true });
      });
      this.currentStatus = STATUS_INITIAL;
    },
    setUpFormData(fileList) {
      this.formData = new FormData();
      const uploadedFiles = fileList.filter((f) => !!f.location);
      const list = fileList.filter((f) => !f.location);
      if (list.length) {
        Array.from(Array(list.length).keys()).forEach((x, index) => {
          if (list[x].file) {
            this.formData.append(this.fieldName, list[x].file, list[x].name);
          } else {
            this.formData.append(this.fieldName, list[x], list[x].name);
          }
          if (typeof list[x].title !== 'undefined' && list[x].title !== null) {
            this.formData.append(`title-${x}`, list[x].title);
          }
          if (typeof list[x].fileType !== 'undefined' && list[x].fileType !== null) {
            this.formData.append(`fileType-${x}`, list[x].fileType);
          }
        });
      }

      if (uploadedFiles.length) {
        this.formData.append('uploadedFiles', JSON.stringify(uploadedFiles));
      }

      this.formData.append('storeMedia', this.uploadToStoreMedia);

      this.formData.append('skipResize', Boolean(this.skipResize));
    }
  },
  mounted() {
    this.reset();
  }
};
